import React, { useState, useRef, useEffect, useContext } from 'react';
import finLogo from '../../../images/icons/fincityWhiteLogo.svg';
import menu from '../../../images/icons/menu.svg';
import { Link } from 'gatsby';
import './Sidebar.css';
import DropLogo from '../../../images/icons/arrow.svg';
import close from '../../../images/icons/close.svg';
import profileAv from '../../../images/icons/profileAv2x.png';
import { getUserNumber } from '../../utils/cookie-utils';
import logOut from '../../../images/icons/logOut.svg';
import Logout from '../Logout/Logout';
import { getUserType } from '../../../common/utils/cookie-utils';
import iconWhiteDash from '../../../images/icons/iconWhiteDash.svg';
import iconBpPartner from '../../../images/icons/iconBpPartner.svg';
import iconCommissions from '../../../images/icons/iconCommissions.svg';
import iconInvoicing from '../../../images/icons/iconInvoicing.svg';
import iconPerformance from '../../../images/icons/IconPerformance.svg';
import iconFcu from '../../../images/icons/iconFcu.svg';
import iconKyc from '../../../images/icons/kyc.svg';
import lead_icon from '../../../images/icons/addLead.svg';
import allComapnyIcon from '../../../images/icons/CompanyGrading/noun_company.svg';
import { useLocation } from '@reach/router';
import {
  enableTeamPerformance,
  enableBankPerformance,
  enablePLStatement,
  enableBankDisbursement,
  enableBankSlabReport,
  showWhatsApp,
  showDisbersement
} from 'gatsby-env-variables';
import { getAcl } from '../../../common/utils/acl-utils';
import Badge from '@material-ui/core/Badge';
import { getNotificationCount } from '../../../common/constants/api';
import whatsApp_icon from '../../../images/icons/whatsApp_icon.svg';
import SvgComponent from '../../../common/components/SvgComponent/SvgComponent';

const isAdmin = () => getAcl()?.acl?.is_rm && getAcl()?.acl?.can_view_all_leads;
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell } from '@fortawesome/pro-solid-svg-icons';
import WhatsAppNotification from '../../components/WhatsAppNotification/WhatsAppNotification';
import NotificationDataContext from '../../../../../lems-ui/src/common/Context/NotificationDataContext';

const navItemsForkyc = () => {
  const temp = getUserType();
  // const temp = 2;
  return [
    ...(temp == 0
      ? [
          {
            icons: iconWhiteDash,
            link: '/app/dashboard',
            label: 'Dashboard',
            id: 'lems_menu_bp_dashboard'
          },
          {
            icons: iconCommissions,
            link: '/app/commissions',
            label: 'Commissions',
            id: 'lems_menu_bp_commissions'
          },
          {
            icons: iconInvoicing,
            link: '/app/invoicing',
            label: 'Invoicing',
            id: 'lems_menu_bp_invoicing'
          },
          {
            icons: iconPerformance,
            link: '/',
            label: 'Performance',
            id: 'lems_menu_bp_performance',

            dropdown: [
              {
                icons: iconFcu,
                link: '/app//business_targets',
                label: 'Business Targets',
                id: 'lems_menu_bp_businessTargets'
              },
              {
                icons: iconFcu,
                link: '/app/call_details',
                label: 'Call Details',
                id: 'lems_menu_bp_callDetails'
              }
            ]
          },
          {
            icons: iconKyc,
            link: '/app/kyc',
            label: 'KYC',
            id: 'lems_menu_bp_kyc'
          },
          {
            icons: iconWhiteDash,
            link: '/app/resource',
            label: 'Resource Center',
            id: 'lems_menu_bp_resource'
          }
        ]
      : []),
    ...(temp == 1
      ? [
          {
            icons: iconWhiteDash,
            link: '/app/dashboard',
            label: 'Dashboard',
            id: 'lems_menu_rm_dashboard',

            dropdown: [
              {
                icons: iconFcu,
                link: '/app/dashboard?type=leads',
                label: 'All Leads',
                id: 'lems_menu_rm_dashboard_allLeads'
              },
              {
                icons: iconFcu,
                link: '/app/dashboard',
                label: 'All Applications',
                id: 'lems_menu_rm_dashboard_allApplications'
              },
              getAcl()?.acl?.is_rm &&
              getAcl()?.acl?.can_create_in_principle_sanction
                ? {
                    icons: iconFcu,
                    link: '/app/dashboard?type=cm',
                    label: 'CM Dashboard',
                    id: 'lems_menu_rm_dashboard_cmDashboard'
                  }
                : {}
            ]
          },
          showWhatsApp
            ? {
                icons: (
                  <SvgComponent img={whatsApp_icon} className="text-white" />
                ),
                link: '/app/whatsapp',
                label: 'Whats App',
                id: 'lems_menu_rm_whatsapp'
              }
            : {},

          {
            icons: iconBpPartner,
            link: '/app/bp',
            label: 'Business Partner',
            id: 'lems_menu_rm_businessPartner'
          },
          {
            icons: iconCommissions,
            link: '/app/commissions',
            label: 'Commissions',
            id: 'lems_menu_rm_commissions'
          },
          {
            icons: iconInvoicing,
            link: '/app/invoicing',
            label: 'Invoicing',
            id: 'lems_menu_rm_invoicing'
          },

          {
            icons: iconPerformance,
            link: '/',
            label: 'Performance',
            id: 'lems_menu_rm_performance',

            dropdown: [
              enableTeamPerformance
                ? {
                    icons: iconFcu,
                    link: '/app/report/teamperformance',
                    label: 'Performance Reports',
                    id: 'lems_menu_rm_teamPerformance',

                    multipleLinks: [
                      '/app/report/teamperformance',
                      '/app/report/performance'
                    ]
                  }
                : {
                    icons: iconFcu,
                    link: '/app/performance_report',
                    label: 'Performance Reports',
                    id: 'lems_menu_rm_teamPerformance'
                  },
              enableBankPerformance
                ? {
                    icons: iconFcu,
                    link: '/app/report/bankperformance',
                    label: 'Bank Performance',
                    id: 'lems_menu_rm_bankPerformance'
                  }
                : {
                    icons: iconFcu,
                    link: '/app/bank_report',
                    label: 'Bank Performance',
                    id: 'lems_menu_rm_bankPerformance'
                  },

              enableBankDisbursement && isAdmin()
                ? {
                    icons: iconFcu,
                    link: '/app/report/bank/disbursement',
                    label: 'Bank Disbursement',
                    id: 'lems_menu_rm_bankDisbursement'
                  }
                : {},

              enableBankSlabReport && isAdmin()
                ? {
                    icons: iconFcu,
                    link: '/app/report/bank/slab',
                    label: 'Bank Slab Report',
                    id: 'lems_menu_rm_bankSlab'
                  }
                : {},

              enablePLStatement
                ? {
                    icons: iconFcu,
                    link: '/app/report/plstatement',
                    label: 'P/L Statement',
                    id: 'lems_menu_rm_plStatement'
                  }
                : {
                    icons: iconFcu,
                    link: '/app/pl_statement',
                    label: 'P/L Statement',
                    id: 'lems_menu_rm_plStatement'
                  },
              {
                icons: iconFcu,
                link: '/app/business_targets',
                label: 'Business Targets',
                id: 'lems_menu_rm_business_targets'
              },
              {
                icons: iconFcu,
                link: '/app/call_details',
                label: 'Call Details',
                id: 'lems_menu_rm_callDetails'
              },
              {
                icons: iconFcu,
                link: '/app/report/call',
                label: 'Call Report',
                id: 'lems_menu_rm_callReport'
              },
              {
                icons: iconFcu,
                link: '/app/report/call/logs',
                label: 'Call Logs',
                id: 'lems_menu_rm_callLogs'
              },
              isAdmin()
                ? {
                    icons: iconFcu,
                    link: '/app/report/funnel',
                    label: 'Funnel Report',
                    id: 'lems_menu_rm_funnel_report'
                  }
                : {},
              {
                icons: iconFcu,
                link: '/app/report/lead-reflex-report',
                label: 'Lead Reflex Report',
                id: 'lems_menu_lead_reflex_report'
              },
              {
                icons: iconFcu,
                link: '/app/report/lead-missed-call-report',
                label: 'Missed Call Report',
                id: 'lems_menu_missed_call_report'
              },
              {
                icons: iconFcu,
                link: '/app/report/disbursement',
                label: 'Disbursement',
                id: 'lems_menu_disbursement_report'
              }
            ]
          },
          {
            icons: iconFcu,
            link: '/app/fcu',
            label: 'FCU',
            id: 'lems_menu_rm_fcu'
          },
          {
            icons: iconWhiteDash,
            link: '/app/resource',
            label: 'Resource Center',
            id: 'lems_menu_rm_resource'
          },
          getAcl()?.acl?.can_access_commission
            ? {
                icons: iconWhiteDash,
                link: '/app/commission',
                label: 'Financial Institutions',
                id: 'lems_menu_rm_financialInstitutions'
              }
            : {},
          {
            icons: iconWhiteDash,
            link: '/app/bre',
            label: 'BRE',
            id: 'lems_menu_bre'
          },
          {
            icons: allComapnyIcon,
            link: '/app/allcompany',
            label: 'All Company',
            id: 'lems_menu_allcompany'
          }
        ]
      : []),
    ...(temp == 2
      ? [
          {
            icons: iconWhiteDash,
            link: '/app/dashboard',
            label: 'Dashboard',
            id: 'lems_menu_cm_dashboard'
          },
          getAcl()?.acl?.can_access_commission
            ? {
                icons: iconWhiteDash,
                link: '/app/commission',
                label: 'Financial Institutions',
                id: 'lems_menu_cm_financialInstitutions'
              }
            : {}
        ]
      : [])
  ];
};

const Sidebar = () => {
  const [showDropdown, setShowDropDown] = useState(false);
  const [showLabels, setShowLabels] = useState(true);
  const [rendered, setRendered] = useState(false);
  const [topElement, setTopElement] = useState(null);
  const [showMobileDropDown, setShowMobileDropDown] = useState(false);
  const [closeOptimiser, setCloseOptimiser] = useState(false);
  const [isMobileScreen, setIsMobileScreen] = useState(window.innerWidth < 768);
  const [activeDropDownOption, setActiveDropDownOptions] = useState(null);
  const [notification, setNotification] = useState(false);
  const [countData, setCountData] = useState(0);
  const messages = useContext(NotificationDataContext);

  useEffect(() => {
    setCountData(messages?.count_notification?.count || 0);
  }, [messages?.count_notification?.count]);

  const myRefs = useRef([]);
  const dropLinkRefs = useRef([]);
  const menuRef = useRef(null);
  const linkRef = useRef([]);
  const appendElement = useRef(null);
  const navRef = useRef(null);
  const arrowRefs = useRef([]);
  const location = useLocation();

  useEffect(() => {
    getNotificationCount()
      .then(res => {
        if (res == 0) return;
        setCountData(`${res}`);
      })
      .catch(error => {});
  }, []);

  const [userDetails, setUserDetails] = useState(
    JSON.parse(localStorage.getItem('userData')) || ''
  );
  /**
   * Convert a template string into HTML DOM nodes
   * @param  {String} str The template string
   * @return {Node}       The template HTML
   */
  var stringToHTML = function(str) {
    if (!showMobileDropDown) appendElement.current.innerHTML = str;
    else appendElement.current.innerHTML = '';
  };

  useEffect(() => {
    showActiveLinkForMobile();
    if (isSmallScreen() && appendElement.current) {
      stringToHTML(topElement);
    }
    dropLinkRefs.current.map((el, i) => {
      if (el.classList.contains('dropActive')) {
        setActiveDropDownOptions(Math.floor(i / 10 - 1));
        setRendered(true);
        setShowDropDown(true);
        el.parentElement.parentElement.parentElement.style.display = 'flex';
      }
    });
    // re-render on resize to small screen
    window.addEventListener('resize', () => {
      window.innerWidth < 768
        ? [setIsMobileScreen(true)]
        : [setIsMobileScreen(false)];
    });

    //It is important to remove EventListener attached on window.
    () =>
      window.removeEventListener('resize', () => {
        window.innerWidth < 768
          ? [setIsMobileScreen(true)]
          : [setIsMobileScreen(false)];
      });
  }, [showMobileDropDown, topElement, isMobileScreen]);

  const NavItems = navItemsForkyc();

  const topElementForAddLead = () =>
    `<div class="flex flex-row justify-between w-full  ">
        <div
          class= 'w-1/5 ml-8 mt-1 '}
        >
          <img class="mr-0 block w-10 h-7" src=${lead_icon} alt="*" />
        </div>
        <div class='w-3/4 text-left mt-1 md:mt-0'>
          <span class=" text-xl  font-roboto font-light text-left">
            Add Lead
          </span>
        </div>
      </div>
    `;

  const DropIcon = (i, index) => {
    return (
      <div
        className={
          (dropLinkRefs.current[`${i + 1}${index}`].classList.contains(
            'dropActive'
          )
            ? 'bg-tealCol-100'
            : 'bg-white') + ' w-3 h-3 rounded-full '
        }
      ></div>
    );
  };

  const isSmallScreen = () => {
    if (window.innerWidth < 768) return true;
    else return false;
  };

  const menuOnclickHandler = () => {
    setTimeout(() => {
      setCloseOptimiser(true);
    }, 300);
    myRefs.current.forEach(element => {
      element.classList.add('hidden');
      element.style.display = 'none';
    });
    setShowDropDown(false);
    setShowLabels(false);
    menuRef.current.classList.remove('md:w-64');
    menuRef.current.classList.add('md:w-20');
  };
  const onCloseClickHandler = () => {
    setCloseOptimiser(false);
    setTimeout(() => {
      setShowLabels(true);
    }, 100);
    menuRef.current.classList.remove('md:w-20');
    menuRef.current.classList.add('md:w-64');
    // }
  };

  const onMobileCloseClickHandler = () => {
    menuRef.current.classList.remove('h-full');
    menuRef.current.classList.add('h-17');
    setTimeout(() => {
      setShowMobileDropDown(false);
    }, 350);
  };

  const mobileMenuOnclickHandler = () => {
    setShowMobileDropDown(true);
    menuRef.current.classList.remove('h-17');
    menuRef.current.classList.remove('fixed');
    menuRef.current.classList.add('h-full');
    menuRef.current.classList.add('absolute');
  };

  const toggleDropDown = id => {
    setRendered(true);
    setActiveDropDownOptions(id);

    // rotating the DropDown Arrow
    arrowRefs?.current[id]?.classList?.toggle(['rotate-180']);

    //flexing the dropdown div
    myRefs.current.map((el, i) => {
      if (i === id) {
        if (myRefs.current[i].style.display === 'flex')
          myRefs.current[i].style.display = 'none';
        else {
          if (showLabels) myRefs.current[i].style.display = 'flex';
        }
      } else {
        myRefs.current[i].style.display = 'none';
      }
    });
  };

  const showActiveLinkForMobile = () => {
    linkRef.current.forEach(element => {
      if (element.parentElement.classList.contains('active'))
        setTopElement(element.innerHTML);
    });
    dropLinkRefs.current.forEach(element => {
      if (element.classList.contains('dropActive')) {
        setTopElement(
          '<div class="ml-12 inline-flex w-full"><div class="w-1/5 "><div class="bg-tealCol-100 w-3 h-3 mt-1 rounded-full"></div></div><div class="w-4/5"><div class=" mx-auto text-tealCol-100 "></div>' +
            element.firstChild.lastChild.innerHTML +
            '</div></div>'
        );
      }
    });
    if (window.location.pathname === '/app/addlead') {
      setTopElement(topElementForAddLead);
    }
  };

  return (
    <React.Fragment>
      <WhatsAppNotification
        notification={notification}
        setNotification={setNotification}
      />{' '}
      <div
        id="sideBar"
        ref={menuRef}
        className={
          (showMobileDropDown
            ? ' overflow-y-auto h-full absolute '
            : ' overflow-hidden h-17 fixed ') +
          ' sideBar bg-black-700  md:h-auto md:min-h-screen  max-h-screen inset-x-0 top-0   md:relative block shadow-lg md:flex-shrink-0  md:overflow-auto w-full  md:w-64 md:pb-0 md:pt-2 pr-0 '
        }
      >
        <div className=" flex flex-row justify-between md:hidden outline-none">
          <div
            className={
              (showMobileDropDown ? ' hidden ' : ' flex flex-1 ') +
              ' md:hidden  cursor-pointer h-19 pb-3 text-white w-4/5  md:w-full   justify-between items-center'
            }
            ref={appendElement}
          ></div>
          <div
            className={
              showMobileDropDown
                ? 'flex flex-row justify-start mt-4 md:hidden ml-8 w-4/5 outline-none truncate '
                : 'hidden'
            }
          >
            <div className="w-10 h-10 ">
              <img src={profileAv} alt="img" />
            </div>
            <div>
              <p className="font-roboto font-normal text-xl  ml-4 mt-2 text-white  truncate">
                {window.innerWidth > 330
                  ? userDetails
                    ? `${(
                        userDetails.name.firstName +
                        ' ' +
                        userDetails.name.lastName
                      ).substring(0, 20)}${
                        (
                          userDetails.name.firstName +
                          ' ' +
                          userDetails.name.lastName
                        ).length > 20
                          ? '...'
                          : ''
                      }`
                    : `${getUserNumber().substring(0, 20)}${
                        getUserNumber().length > 20 ? '...' : ''
                      }`
                  : userDetails
                  ? `${(
                      userDetails.name.firstName +
                      ' ' +
                      userDetails.name.lastName
                    ).substring(0, 10)}${
                      (
                        userDetails.name.firstName +
                        ' ' +
                        userDetails.name.lastName
                      ).length > 10
                        ? '...'
                        : ''
                    }`
                  : `${getUserNumber().substring(0, 10)}${
                      getUserNumber().length > 10 ? '...' : ''
                    }`}
              </p>
            </div>
          </div>
          {!showMobileDropDown && (
            <div className="flex items-center mr-4">
              <Badge badgeContent={countData} color="error" max={999}>
                <FontAwesomeIcon
                  icon={faBell}
                  size="2x"
                  style={{
                    color: 'white',
                    cursor: 'pointer'
                  }}
                  onClick={() => {
                    setNotification(!notification);
                  }}
                />
              </Badge>
            </div>
          )}
          {!showMobileDropDown ? (
            <div
              className="w-1/5 mt-7 cursor-pointer outline-none bg-transparent appearance-none"
              onClick={mobileMenuOnclickHandler}
            >
              <img
                className="block outline-none bg-transparent"
                src={menu}
                alt="_-"
              />
            </div>
          ) : (
            <div
              className="w-1/5 mt-7 -ml-4 cursor-pointer outline-none bg-transparent appearance-none "
              onClick={onMobileCloseClickHandler}
            >
              <img
                className="outline-none bg-transparent "
                src={close}
                alt="close"
              />
            </div>
          )}
        </div>
        <hr className="md:hidden w-5/6 mx-auto mt-7 h-0.5 text-grey-600" />
        {/* md menuBar */}
        <div
          className={
            '  inline-flex ' +
            (showLabels
              ? 'md:inline-flex w-full justify-around '
              : ' md:invisible absolute  ')
          }
        >
          <div className="hidden md:block mt-8">
            <img
              className=" h-14 w-34 relative m-auto"
              src={
                userDetails?.tenant?.logoUrl
                  ? userDetails.tenant.logoUrl
                  : finLogo
              }
              alt="fincityLogo"
            />
          </div>
          <div
            className="hidden md:block md:relative md:mr-6 md:mt-12 block cursor-pointer"
            onClick={menuOnclickHandler}
          >
            <img src={menu} alt="_-" />
          </div>
        </div>
        {/* close icons */}
        <div
          className={
            !showLabels && closeOptimiser
              ? 'mt-12  w-full cursor-pointer'
              : 'hidden'
          }
          onClick={onCloseClickHandler}
        >
          <img className="mx-auto " src={close} alt="close" />
        </div>
        {/* <nav className="flex-1">
      <ul className="w-full font-roboto text-base md:text-sm font-light md:font-regular list-reset flex flex-col text-center md:text-left"> */}
        <nav
          ref={navRef}
          className=" w-full left-0 top-0  md:pt-2 md:relative md:w-64 content-start md:text-left justify-between"
        >
          <ul className="w-full font-roboto text-base  md:font-regular list-reset flex flex-col py-0 md:py-3  text-center align_left md:text-left">
            {NavItems.map(
              ({ icons, link, label, dropdown, id }, i) =>
                label && (
                  <li
                    key={link}
                    className={
                      (activeDropDownOption === i && dropdown
                        ? 'border-l-10 border-tealCol-100 bg-black-900  '
                        : '') + '  w-full my-px'
                    }
                  >
                    {dropdown ? (
                      <button
                        type="button"
                        className="font-roboto h-19  font-normal block  cursor-pointer  text-center text-white  w-full  flex flex-1 justify-between items-center"
                        onClick={() => {
                          toggleDropDown(i);
                          setShowDropDown(!showDropdown);
                        }}
                      >
                        <div
                          ref={el => (linkRef.current[i] = el)}
                          className={
                            (activeDropDownOption === i && dropdown
                              ? '-ml-2.5'
                              : '') + ' inline-flex w-full items-center '
                          }
                        >
                          <div
                            className={
                              (showLabels ? 'w-1/5 ml-8' : 'w-full ml-7') +
                              '  mt-2 '
                            }
                          >
                            <img className="mr-0 block" src={icons} alt="*" />
                          </div>
                          <div
                            className={
                              (activeDropDownOption === i && dropdown
                                ? 'ml-0.5'
                                : '') +
                              (showLabels ? ' w-3/4 text-left' : ' hidden')
                            }
                          >
                            <span className="w-full block text-lg text-white font-roboto font-light text-left">
                              {label}
                            </span>
                          </div>
                        </div>
                        {dropdown && dropdown.length && showLabels ? (
                          <img
                            id="dropDown"
                            ref={el => (arrowRefs.current[i] = el)}
                            className={
                              ' h-2 absolute block right-0 transform  text-white w-3 mr-10 md:mr-4 '
                            }
                            src={DropLogo}
                            alt="dropDown"
                          />
                        ) : null}
                      </button>
                    ) : (
                      <Link
                        className=" cursor-pointer h-19 md:py-3 text-white  w-full  flex flex-1 justify-between items-center"
                        to={link}
                        id={id}
                        activeClassName=" active "
                      >
                        <div
                          className=" inline-flex w-full  "
                          ref={el => (linkRef.current[i] = el)}
                        >
                          <div
                            className={
                              (showLabels ? 'w-1/5 ml-8' : 'w-full ml-7 ') +
                              '  mt-0.5 '
                            }
                          >
                            {typeof icons == 'string' ? (
                              <img className="mr-0 block" src={icons} alt="*" />
                            ) : (
                              icons
                            )}
                          </div>
                          <div
                            className={
                              showLabels ? 'w-3/4 text-left  md:mt-0' : 'hidden'
                            }
                          >
                            <span className=" text-lg  font-roboto font-light text-left">
                              {label}
                            </span>
                          </div>
                        </div>
                      </Link>
                    )}
                    {dropdown && dropdown.length ? (
                      <ul
                        style={{ display: 'none ' }}
                        className={
                          showLabels
                            ? ' flex flex-col justify-center md:w-full '
                            : ' hidden '
                        }
                        ref={el => (myRefs.current[i] = el)}
                      >
                        {dropdown.map(
                          ({ link, label, multipleLinks, id }, index) =>
                            label && (
                              <div key={index} className="inline-flex md:flex ">
                                <div className="w-1/5 block md:hidden"></div>
                                <li
                                  id={id}
                                  key={link}
                                  className="flex flex-col justify-center  md:ml-0 align_left md:text-left  my-px"
                                >
                                  <Link
                                    className="relative text-white align_left md:text-left"
                                    to={link}
                                    id={id}
                                    activeClassName=" dropActive "
                                    ref={el =>
                                      (dropLinkRefs.current[
                                        `${i + 1}${index}`
                                      ] = el)
                                    }
                                    getProps={({ isCurrent }) => {
                                      if (
                                        multipleLinks &&
                                        multipleLinks?.length > 0 &&
                                        multipleLinks?.includes(
                                          location.pathname
                                        )
                                      ) {
                                        return {
                                          className:
                                            'relative text-white align_left md:text-left dropActive'
                                        };
                                      } else if (
                                        `${location.pathname}${location.search}` ===
                                        link
                                      ) {
                                        return {
                                          className:
                                            'relative text-white align_left md:text-left dropActive'
                                        };
                                      }
                                    }}
                                  >
                                    <div className="inline-flex w-full ">
                                      <div
                                        className="w-7
                              ml-8 md:ml-12 mt-0.5 pt-1 "
                                      >
                                        {rendered ? DropIcon(i, index) : null}
                                      </div>
                                      <div className="">
                                        <span className=" text-sm font-roboto font-light text-left ">
                                          {label}
                                        </span>
                                      </div>
                                    </div>
                                  </Link>
                                </li>
                              </div>
                            )
                        )}
                      </ul>
                    ) : null}
                  </li>
                )
            )}
          </ul>
        </nav>
        {showLabels ? (
          <div className="hidden  w-full md:block p-2 mx-auto relative bottom-0">
            <div className="separator mb-4 text-xs">Powered by</div>
            <img
              className="block h-6 w-28 relative m-auto"
              src={finLogo}
              alt="fincityLogo"
            />
          </div>
        ) : null}
        <div className=" mx-auto w-40 md:hidden border-2 border-grey-600 h-9 mt-20 mb-6 rounded-lg">
          <div
            className="flex flex-row md:hidden justify-center items-center mx-auto text-center cursor-pointer"
            onClick={Logout}
          >
            <div>
              <img src={logOut} alt="profile" />
            </div>
            <div>
              <p className="text-grey-998 ml-3 font-roboto font-normal text-base mt-1 mb-0.5">
                Logout
              </p>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
export default Sidebar;
